import { formatFileSize } from '@/lib/format';

/** Files picked before sending, each with « Retirer » (screens 02 and 03). */
export function SelectedFiles({ files, onRemove }: { files: File[]; onRemove: (index: number) => void }) {
  if (files.length === 0) return null;
  return (
    <ul className="m-0 flex list-none flex-col gap-1.5 p-0">
      {files.map((file, index) => (
        <li key={`${file.name}-${index}`} className="flex items-center gap-2.5 text-[13px] text-foreground-secondary">
          <span className="rounded-control bg-muted px-2.5 py-1">
            {file.name} · {formatFileSize(file.size)}
          </span>
          <button
            type="button"
            onClick={() => onRemove(index)}
            className="min-h-8 cursor-pointer border-0 bg-transparent px-1.5 font-[inherit] text-[13px] text-muted-foreground"
          >
            Retirer
          </button>
        </li>
      ))}
    </ul>
  );
}
